module.exports = __webpack_public_path__ + "img/client.616fcc9d.png";